import { useState, useEffect } from 'react';
import { useParams, useNavigate } from "react-router-dom";
import { Container } from "@mui/material";
import axios from 'axios';
import Loader from "../Loader";
import { withPather } from 'react-pather';
import { Box } from '@mui/material';
import { useDispatch } from 'react-redux';
import { setUser } from '../../slices/userSlice';
import { useSelector } from 'react-redux';
import { useToken } from '../../hooks';
import { setTheme } from '../../slices/themeSlice';
import { setToken as setUUT } from '../../slices/tokenSlice';

const ConfirmAccount = ({ pather }) => {

    const navigate = useNavigate();
    const { uut } = useParams();
    const { setToken } = useToken();
    const [error, setError] = useState(null);
    const [loading, setLoading] = useState(true);
    const dispatch = useDispatch();
    const currentUser = useSelector(state => state.user.value);

    useEffect(() => {
        setLoading(true);
        axios.post(
            pather.reverse(pather.back.confirmAccount, { uut })
        ).then(response => {
            const data = response.data;
            const action = data?.action;
            if (action === 'activation'){
                dispatch(setUser({
                    isLogined: true,
                    isConfirmed: data.is_confirmed,
                    email: data.email,
                    username: data.username,
                    uut: data.uut,
                    roles: data.roles,
                    primaryColor: data.primary_color,
                }));
                setToken(data.access_token);
                if(uut !== data.uut) dispatch(setUUT(data.uut));
                if(data?.user_theme) dispatch(setTheme(data?.user_theme));
                navigate(pather.front.dashboard);
            } 
            else {
                dispatch(setUser({
                    ...currentUser,
                    isConfirmed: true,
                }));
                window.location.href = pather.front.dashboard;
            }
        }).catch(resp => {
            const data = resp?.response?.data;
            setError(data?.status);
            console.log(data);
        }).finally(() => {
            setLoading(false);
        })
    }, [])

    return (
        <Container sx={{
            minHeight: '550px', display: 'flex',
            alignItems: 'center', justifyContent: 'center'
        }}>
            {
                loading || !error ?
                <Loader/> : 
                <Box sx={{fontSize: '36px'}}>
                    {error}
                </Box>
            }
        </Container>
    );
}

export default withPather()(ConfirmAccount);